import { defineMessage } from 'services/localization';

export const messages = {
    rejectedExternally: defineMessage('the_request_has_been_rejected_in_cin_core'),
    postApprovalChangeDetected: defineMessage('changes_have_been_made_in_cin_core_after_approval'),
    updatedExternallyResetTemplate: defineMessage('this_request_has_been_u__workflow_has_restarted'),
    emailToPartnerSent: defineMessage('purchase_order_has_been_sent_to_the_customer'),
};
